import { resultsPage } from "./constants";
import { loadCompetitionPage } from "./loaders/loadCompetitionPage";
import { loadMatchPage } from "./loaders/loadMatchPage";
import { loadTeamPage } from "./loaders/loadTeamPage";

/**
 * Un loader por tipo de página.
 * `home` no está: su fixture depende de la fecha elegida y se pide desde el cliente.
 */
const loaders = {
    [resultsPage.competition]: loadCompetitionPage,
    [resultsPage.team]: loadTeamPage,
    [resultsPage.match]: loadMatchPage,
};

/**
 * Carga la data de la página resuelta por `resolveResultsRoute` (competition | team | match).
 * Devuelve siempre un objeto: `{}` significa "sin información para esta ruta".
 */
export const loadResultsPage = async (route, { competitionsToMap = [] } = {}) => {
    const load = loaders[route?.page];
    if (!load || competitionsToMap.length === 0) return {};

    return (await load({ ...route, competitionsToMap })) ?? {};
};